// Menu: Shortlist Counter
// 

JLM.MD.MenuBarCounter = function( container ) {
	
	const INSTANCE = {};
	
	
	// Variables: Private _______________________________________________________
	
	// References
	let counter, count_element;
	
	
	
	// Variables: Public ________________________________________________________
	
	INSTANCE.tally = null;
	
	
	
	// Constructor ______________________________________________________________
	
	function init() {
		// Set references
		counter = $('.counter', container);
		count_element = $('span', counter);
	}
	
	
	
	// Methods: Private _________________________________________________________
	
	// Flash to highlight change
	// 
	function showFlash() {
		let flash = $('<span class="flash" />').appendTo( container );
		setTimeout(function() {
			flash.addClass('reveal');
		}, 20);
		setTimeout(function() {
			flash.remove();
		}, 1500);
	}
	
	
	
	// Methods: Public __________________________________________________________
	
	// Update counter value
	// 
	INSTANCE.update = function( tally, is_setup ) {
		// Animate new value
		let count_element_previous = count_element;
		if ( tally > INSTANCE.tally ) {
			count_element = $('<span class="more">' + tally + '</span>').appendTo( counter );
			setTimeout(function() {
				count_element.removeClass('more');
				count_element_previous.addClass('less');
			}, 20);
		} else {
			count_element = $('<span class="less">' + tally + '</span>').appendTo( counter );
			setTimeout(function() {
				count_element.removeClass('less');
				count_element_previous.addClass('more');
			}, 20);
		}
		
		// Remove old value
		setTimeout(function() {
			count_element_previous.remove();
		}, 1000);
		
		// Flash highlight
		if ( !is_setup && INSTANCE.tally !== null && tally > INSTANCE.tally ) showFlash();
		
		// Update values
		counter.attr('data-count', tally);
		INSTANCE.tally = tally;
	};
	
	
	
	// Initial Setup ____________________________________________________________
	
	init();
	return INSTANCE;
	
};